import * as actionTypes from 'redux/actions'

const initialState = {
  paymentMethod: 'Visa',
  holder: 'John Doe',
  number: '5285789834126825',
  date: '10/22'
}

const creditcardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CREDIT_CARDS: {
      return {
        ...action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default creditcardsReducer
